module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1532-0e9a6588bd32418c5a5bc70197366a4c.png";